import { BusinessLine } from '@cemex-core/cmx-api/models/business-lines/business-line';
import { Order } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { OrderStrategyResponse } from '../../order-builder/models/order-strategy-response';

export enum OneClickOrdersActionTypes {
  LOAD = '[One Click] Load order previews',
  LOAD_COMPLETE = '[One Click] Load order previews completed',
  SELECT_ORDER = '[One Click] Set order preview',
  SELECT_ORDER_DETAIL = '[One Click] Set order detail preview',
  SELECT_ORDER_DETAIL_ERROR = '[One Click] Set order detail error preview',
  UPDATE_ORDER = '[One Click] Update order preview',
  SELECTED_ORDER_FROM_TABLE = '[One Click] Set order from table',
  PLACE_ORDER = '[One Click] Place order preview',
  PLACE_ORDER_COMPLETED = '[One Click] Place order completed preview',
  SET_RECEIVING_PERSON_NAME = '[One Click] Set order receiving person name',
  SET_RECEIVING_PERSON_PHONE = '[One Click] Set order receiving person phone',
  TOGGLE_ADDING_RECEIVING_PERSON = '[One Click] Toggle adding receiving person',
  HAS_BUSINESSLINE_RIGHT = '[One Click] Has BusinessLine Right',
  SET_VALID_ORDER = '[One Click] Set order validity',
  RESET = '[One Click] Reset',
}

export class OneClickOrdersLoadAction implements Action {
  readonly type = OneClickOrdersActionTypes.LOAD;

  constructor() {}
}

export class OneClickOrdersLoadCompleteAction implements Action {
  readonly type = OneClickOrdersActionTypes.LOAD_COMPLETE;

  constructor(public payload: Order[]) {}
}

export class OneClickSelectOrderAction implements Action {
  readonly type = OneClickOrdersActionTypes.SELECT_ORDER;

  constructor(public payload: Order) {}
}

export class OneClickSelectOrderDetailAction implements Action {
  readonly type = OneClickOrdersActionTypes.SELECT_ORDER_DETAIL;

  constructor(public payload: number) {}
}

export class OneClickSelectOrderDetailErrorAction implements Action {
  readonly type = OneClickOrdersActionTypes.SELECT_ORDER_DETAIL_ERROR;

  constructor(public payload: any) {}
}

export class OneClickUpdateOrderAction implements Action {
  readonly type = OneClickOrdersActionTypes.UPDATE_ORDER;

  constructor(public payload: Order) {}
}

export class OneClickSelectedOrderFromTableAction implements Action {
  readonly type = OneClickOrdersActionTypes.SELECTED_ORDER_FROM_TABLE;

  constructor(public payload: boolean) {}
}

export class OneClickPlaceOrderAction implements Action {
  readonly type = OneClickOrdersActionTypes.PLACE_ORDER;

  constructor(public payload: Order) {}
}

export class OneClickPlaceOrderCompletedAction implements Action {
  readonly type = OneClickOrdersActionTypes.PLACE_ORDER_COMPLETED;

  constructor(public payload: OrderStrategyResponse) {}
}

export class OneClickSetOrderReceivingPersonNameAction implements Action {
  readonly type = OneClickOrdersActionTypes.SET_RECEIVING_PERSON_NAME;

  constructor(public payload: string) {}
}

export class OneClickSetOrderReceivingPersonPhoneAction implements Action {
  readonly type = OneClickOrdersActionTypes.SET_RECEIVING_PERSON_PHONE;

  constructor(public payload: string) {}
}

export class OneClickOrderToggleAddingReceivingPersonAction implements Action {
  readonly type = OneClickOrdersActionTypes.TOGGLE_ADDING_RECEIVING_PERSON;

  constructor() {}
}

export class OneClickSetValidOrder implements Action {
  readonly type = OneClickOrdersActionTypes.SET_VALID_ORDER;

  constructor(public payload: boolean) {}
}

export class OneClickOrderResetAction implements Action {
  readonly type = OneClickOrdersActionTypes.RESET;

  constructor() {}
}

export class OneClickOrderHasBusinessLineRightAction implements Action {
  readonly type = OneClickOrdersActionTypes.HAS_BUSINESSLINE_RIGHT;

  constructor(public payload: BusinessLine | boolean) {}
}

export type OneClickOrdersActions =
  | OneClickOrdersLoadAction
  | OneClickOrdersLoadCompleteAction
  | OneClickSelectOrderAction
  | OneClickUpdateOrderAction
  | OneClickSelectedOrderFromTableAction
  | OneClickPlaceOrderAction
  | OneClickPlaceOrderCompletedAction
  | OneClickSetOrderReceivingPersonNameAction
  | OneClickSetOrderReceivingPersonPhoneAction
  | OneClickOrderResetAction
  | OneClickOrderToggleAddingReceivingPersonAction
  | OneClickSelectOrderDetailAction
  | OneClickSelectOrderDetailErrorAction
  | OneClickSetValidOrder
  | OneClickOrderResetAction
  | OneClickOrderHasBusinessLineRightAction;
